import o from "./novoui-vuejs109.js";
import "./novoui-vuejs110.js";
import r from "./novoui-vuejs73.js";
const m = /* @__PURE__ */ r(o, [["__scopeId", "data-v-8c6edce0"]]);
export {
  m as default
};
